import { km_get_chat_pduli_ai_reducers } from "../reducers/ChatPduliAIReducers";
import {
  km_get_koselor_session_reducers,
  km_post_koselor_session_reducers,
} from "../reducers/KonselorSessionReducers";
import { pduli_recording_reducers } from "../reducers/recordingReducers";
import {
  km_get_session_konseling_reducers,
  km_get_session_konseling_status_reducers,
  km_pduli_is_will_time_over_reducers,
  km_stop_session_konseling_reducers,
} from "../reducers/SessionKonselingReducers";
import { km_post_validation_sesssion_konseling_reducers } from "../reducers/ValidationSessionKonselingReducers";

const modulKonselor = {
  km_post_validation_sesssion_konseling:
    km_post_validation_sesssion_konseling_reducers,
  km_get_session_konseling: km_get_session_konseling_reducers,
  km_get_koselor_session: km_get_koselor_session_reducers,
  km_post_koselor_session: km_post_koselor_session_reducers,
  km_get_chat_pduli_ai: km_get_chat_pduli_ai_reducers,

  pduli_recording: pduli_recording_reducers,
  km_pduli_is_will_time_over: km_pduli_is_will_time_over_reducers,
  km_stop_session_konseling: km_stop_session_konseling_reducers,
  km_get_session_konseling_status: km_get_session_konseling_status_reducers,
};

export default modulKonselor;
